import api from './base'

export default {
  getAll () {
    return api().get(`company/tax_types`)
  },
  getById ({ id }) {
    return api().get(`company/tax_types/${id}`)
  },
  save ({ item }) {
    return api().put(`company/tax_types`, item)
  },
  delete ({ id }) {
    return api().delete(`company/tax_types/${id}`)
  }
}
